export default __webpack_public_path__ + "static/media/dream-orphans-bd.1d479dff.ttf";